import h5AppReducer from './slices/app';
import bankruptcyCacheReducer from './slices/CL/bankruptcyCache';
import clCredit from './slices/CL/clCredit';
import clPreApprovalSlice from './slices/CL/clPreApproval';
import cmcCredit from './slices/CMC/cmcCredit';
import employInformation from './slices/employInformation';
import billMgmtReducer from './slices/KKC/billMgmt';
import creditApplyReducer from './slices/KKC/creditApply';
import eddaReducer from './slices/KKC/edda';
import mgmReducer from './slices/KKC/mgm';
import repaymentReducer from './slices/KKC/repayment';
import withdrawalReducer from './slices/KKC/withdrawal';
import pubReducer from './slices/pub';
import unionLoanCacheReducer from './slices/unionLoanCache';
import webPubReducer from './slices/webpub';

export default {
  creditApplyReducer,
  withdrawalReducer,
  h5AppReducer,
  eddaReducer,
  repaymentReducer,
  billMgmtReducer,
  mgmReducer,
  clCredit,
  cmcCredit,
  webPubReducer,
  pubReducer,
  clPreApprovalSlice,
  employInformation,
  unionLoanCacheReducer,
  bankruptcyCacheReducer,
};
